// @material-ui/icons
import Dashboard from "@material-ui/icons/Dashboard";
import Audit from "@material-ui/icons/TrackChanges";
import Landing from "@material-ui/icons/FlightLandOutlined";

import MainLandingPage from "../layouts/Landing/RegionalLanding/landing";

import DashboardPage from "views/Dashboard/Dashboard.jsx";
import NotFound from "views/NotFound/Index.jsx";
import HelpIcon from "@material-ui/icons/HelpOutline"
import HelpCenter from "../views/HelpCenter";

const dashboardRoutes = [
    {
        path: "/main-landing",
        sidebarName: "Main Landing",
        navbarName: "Main Landing",
        icon: Landing,
        component: MainLandingPage,
        subMenu: [],
    },
    {
        path: "/app",
        sidebarName: "Dashboard",
        isNotVisible: true,
        navbarName: "Dashboard",
        icon: Dashboard,
        subMenu: [],
        component: DashboardPage
    },
    {
        path: "/app/dashboard",
        sidebarName: "Dashboard",
        isNotVisible: true,
        navbarName: "Dashboard",
        icon: Dashboard,
        subMenu: [],
        component: DashboardPage
    },
    {
        path: "/app/help-center",
        sidebarName: "Help Center",
        navbarName: "Help Center",
        icon: HelpIcon,
        component: HelpCenter,
        subMenu: []
      },
    {
        isNotVisible: true,
        path: "**",
        sidebarName: "Not found",
        navbarName: "Not Found",
        icon: Audit,
        subMenu: [],
        component: NotFound,

    }
];

export default dashboardRoutes;



// WEBPACK FOOTER //
// ./src/routes/executiveUser.jsx